import {Toast} from "primereact/toast";
import React, {useEffect, useRef, useState} from "react";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {UseLoader} from "../../../hooks/useLoader";
import {error} from "../../../shared/utils/utils";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {confirmDialog} from "primereact/confirmdialog";
import {updateAsociadoDeduccion} from "../../../api/asociadoDeduccion.service";
import {actualizarData} from "../../../api/pensionado.service";


export const ModalEditarPensionado= ({show, hide, fields}) => {


    const [handleLoad] = UseLoader();
    const toast = useRef(null);

    const initParams= {
        estado: "",
        estado_id: "",
        porcentaje: "",
        asociado_id: ""
    };

    const [field, setField] = useState(initParams);

    useEffect(() => {
        setField({
            estado: fields.estado,
            estado_id: fields.estado_id,
            porcentaje: fields.porcentaje,
            asociado_id: fields.asociado_id,
            nombre: fields.nombre
        })

        return () => {
            setField(initParams)
        };
    }, [fields]);

    const onSubmit= (e) => {
        try {
            e.preventDefault();

            const payload= {
                estado: field.estado_id,
                porcentaje: field.porcentaje,
                asociado_id: field.asociado_id,
                pensionado_id: fields.pensionado_id
            }

            if(payload.estado === '' || payload.porcentaje === '' ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const response = await actualizarData(payload);
                    const data = await response.data;
                    handleLoad(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }
                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide();
                }
            })

        } catch (e) {
            handleLoad(false)
            console.log(e)
        }
    }


    return(
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar Compensacion" visible={show} style={{width: '70vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Editar información pensionado
                            </h6>
                            <div className="row">
                            <ContainerGroupForm width="lg:w-4/12">
                                <label
                                    className="label-form"
                                    htmlFor="asociado"
                                >
                                    Asociado
                                </label>
                                <select
                                    className="form-input-small"
                                    value={field.asociado_id}
                                    disabled
                                    id="asociado">
                                    <option value={field.asociado_id}>{field.nombre}</option>
                                </select>
                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form"
                                    htmlFor="porcentaje"
                                >
                                    porcentaje % *
                                </label>
                                <input
                                    id="porcentaje"
                                    type="number"
                                    className="form-input-small"
                                    value={field.porcentaje}
                                    required maxLength={3}
                                    onChange={(e) => setField({...field, porcentaje: e.target.value})}
                                />
                                {error(field.porcentaje, 'required')}
                                {error(field.porcentaje, 'maxLength', 3)}
                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-4/12">
                                <label
                                    className="label-form"
                                    htmlFor="estado"
                                >
                                    Estado
                                </label>
                                <select
                                    className="form-input-small"
                                    required
                                    value={field.estado_id}
                                    id="estado"
                                    onChange={(e) => setField({...field, estado_id: e.target.value})}
                                >
                                    <option value="A">Activo</option>
                                    <option value="I">Inactivo</option>
                                </select>
                            </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-3/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Actualizar
                                    </button>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-3/12">
                                    <button
                                        className="warning-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    )
}
